/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */
import type { ReactNode } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Pressable } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

type Props = {
	children: ReactNode;
	onClick: () => void;
};

const styles = cssMap({
	button: {
		backgroundColor: token('color.background.neutral.subtle', 'transparent'),
		color: token('color.link', '#0C66E4'),
		font: token(
			'font.body',
			'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
		),
		fontWeight: token('font.weight.medium', '500'),
		maxWidth: '150px',
		overflow: 'hidden',
		paddingBlock: token('space.0', '0px'),
		paddingInline: token('space.0', '0px'),
		'&:hover': {
			textDecoration: 'underline',
		},
	},
});

export const LinkButton = ({ children, onClick }: Props) => {
	return (
		<Pressable onClick={onClick} xcss={styles.button}>
			{children}
		</Pressable>
	);
};
